import { createContext, useContext } from "react";

export interface UserInterface {
  RpUserName: string;
  RP_USER_TYPE: string;
  aio: string;
  aud: string;
  azp: string;
  azpacr: string;
  claims: string[];
  eeid: string;
  exp: string;
  iat: string;
  iss: string;
  name: string;
  nbf: string;
  preferred_username: string;
  rh: string;
  sid: string;
  uti: string;
  ver: string;
}

/**
 * A helper to create a Context and Provider with no upfront default value, and
 * without having to check for undefined all the time.
 */
const createUserContext = <A extends object | null>() => {
  const ctx = createContext<A | undefined>(undefined);
  const useUserCtx = () => {
    const c = useContext(ctx);
    if (c === undefined) {
      throw new Error("useUserCtx must be inside a Provider with a value");
    }
    return c;
  };
  return [useUserCtx, ctx] as const;
};

export const [useUserContext, UserContext] =
  createUserContext<UserInterface>();

